import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { horizontalStatusPageNavEntrypoint } from '@atlassian/jira-horizontal-nav-status-page/entrypoint.tsx';
import { communicationsStatusPageManageEntrypoint } from '@atlassian/jira-communications-status-page-manage/entrypoint.tsx';

export const statusPageManagePageEntrypoint = createPageEntryPoint({
	main: communicationsStatusPageManageEntrypoint,
	topNavigationMenuId: MENU_ID.STATUS_PAGE_MANAGE,
	horizontalNavigation: horizontalStatusPageNavEntrypoint,
});
